import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _ImageTypeFormat, _CameraTypeToFacingMo;

import { CameraType, ImageType } from "./CameraModule.types";
export var VIDEO_ASPECT_RATIOS = {
  '3840x2160': 3840 / 2160,
  '1920x1080': 1920 / 1080,
  '1280x720': 1280 / 720,
  '640x480': 640 / 480,
  '352x288': 352 / 288
};
export var PictureSizes = Object.keys(VIDEO_ASPECT_RATIOS);
export var ImageTypeFormat = (_ImageTypeFormat = {}, _defineProperty(_ImageTypeFormat, ImageType.jpg, 'image/jpeg'), _defineProperty(_ImageTypeFormat, ImageType.png, 'image/png'), _ImageTypeFormat);
export var MinimumConstraints = {
  audio: false,
  video: true
};
export var CameraTypeToFacingMode = (_CameraTypeToFacingMo = {}, _defineProperty(_CameraTypeToFacingMo, CameraType.front, 'user'), _defineProperty(_CameraTypeToFacingMo, CameraType.back, 'environment'), _CameraTypeToFacingMo);
export var FacingModeToCameraType = {
  user: CameraType.front,
  environment: CameraType.back
};